














































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { FormItem, Input, Option, Select } from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// Mixins
import carriers from '@/mixins/carrierOptions';
import places from '@/mixins/placeOptions';
import partners from '@/mixins/partnerOptions';
import vessels from '@/mixins/vesselOptions';

// types
import {
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    UtcDatePicker,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class TransportInformationImport extends Mixins(
  carriers,
  partners,
  places,
  vessels
) {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;

  created() {
    // disable auto select for place select
    this.autoSelect = false;
    // init transport type for place select
    this.transportationType = this.document.data.transportationType;
  }

  get customerOrganization() {
    return this.document?.shipment?.customerOrganization;
  }

  get seaCarrier() {
    return this.value.seaCarrier;
  }

  set seaCarrier(data) {
    this.$emit('input', { ...this.value, seaCarrier: data });
  }

  get consolidator() {
    return this.value.consolidator;
  }

  set consolidator(data) {
    this.$emit('input', { ...this.value, consolidator: data });
  }

  get airCarrier() {
    return this.value.airCarrier;
  }

  set airCarrier(data) {
    this.$emit('input', { ...this.value, airCarrier: data });
  }

  get masterBlNumber() {
    return this.value.masterBlNumber;
  }

  set masterBlNumber(data) {
    this.$emit('input', { ...this.value, masterBlNumber: data });
  }

  get portOfDischarge() {
    return this.value.portOfDischarge;
  }

  set portOfDischarge(data) {
    this.$emit('input', { ...this.value, portOfDischarge: data });
  }

  get houseBlNumber() {
    return this.value.houseBlNumber;
  }

  set houseBlNumber(data) {
    this.$emit('input', { ...this.value, houseBlNumber: data });
  }

  get vesselName() {
    return this.value.vesselName;
  }

  set vesselName(data) {
    this.$emit('input', { ...this.value, vesselName: data });
  }

  get voyageNumber() {
    return this.value.voyageNumber;
  }

  set voyageNumber(data) {
    this.$emit('input', { ...this.value, voyageNumber: data });
  }

  get flightNumber() {
    return this.value.flightNumber;
  }

  set flightNumber(data) {
    this.$emit('input', { ...this.value, flightNumber: data });
  }

  get estimatedDateOfArrival() {
    return this.value.estimatedDateOfArrival;
  }

  set estimatedDateOfArrival(data) {
    this.$emit('input', { ...this.value, estimatedDateOfArrival: data });
  }
}
